import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { cn } from '@/lib/utils';

type PlaceholderCheckboxProps = {
  checked?: boolean;
  className?: string;
};

export function CheckboxPlaceholder({
  checked = false,
  className,
}: PlaceholderCheckboxProps) {
  return (
    <div
      role="checkbox"
      aria-checked={checked}
      aria-disabled
      tabIndex={-1}
      className={cn(
        'pointer-events-none select-none relative',
        'peer h-4 w-4 shrink-0 rounded-[0.25rem] border-2 border-neutrals-N300 ring-offset-background',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutrals-N500 focus-visible:ring-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-50',
        checked &&
          'bg-primary-blue-B600 text-white border-0 dark:bg-primary-blue-B400',
        className,
      )}>
      {checked && (
        <span className="absolute inset-0 flex items-center justify-center text-current leading-none">
          <FontAwesomeIcon icon={faCheck} className="fa-xs h-3 w-3" />
        </span>
      )}
    </div>
  );
}
